import { Injectable } from '@angular/core';
import moment from 'moment';
import { AuthService } from 'src/app/@auth/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { RxCluZLogDocumentType } from '../@schemas/clu_zlog.schema';
import { CashDeskCoreRxDbService } from './m-cashdesk-core-rxdb.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';
import { RxPDeviceDocumentType } from '../@schemas/p_device.schema';

@Injectable()
export class CashDeskZCluZLogService {

    constructor(
      private _authService : AuthService,
      private _cashDeskRxDbService : CashDeskCoreRxDbService,
      private _tauriService: TauriService
    ) {

    }

    private async doGetGenerateDefaultZLogItem_ZLogFn(LOG_EVT_CODE : string, LOG_EVT_TARGET : string, LOG_EVT_LIB : string, LOG_EVT_DATA : string) : Promise<RxCluZLogDocumentType | null> {
        const authSessionDto: any = this._authService.authenticatedSession$.value!;
        if(!authSessionDto || !authSessionDto.SITE_ITEM || !authSessionDto.FO_PARAMS || !authSessionDto.FO_PARAMS.M_CAISSE_PERM || !authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM) return null;

        let DEVICE : RxPDeviceDocumentType | null = null;
        if (this._tauriService.isTauri) {
          try { DEVICE = await this._tauriService.doGetPDeviceItemByCaissegidAction(localStorage.getItem('LS_FE_AUTH_CASHDESK_GID')!); } catch {}
        } else {
          const query_DEVICE = this._cashDeskRxDbService.db.pdevice.findOne({ selector: { "CAISSEGID": { "$eq": localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') } }});
          DEVICE = await query_DEVICE.exec();
        }
        if(!DEVICE) return null;

        let _zlogItem = {
            LOG_GID : uuidv4(),
            LOG_DATEEVENT : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            LOG_EVT_CODE : LOG_EVT_CODE,
            LOG_EVT_TARGET : LOG_EVT_TARGET,
            LOG_EVT_LIB : LOG_EVT_LIB,
            LOG_EVT_DATA : LOG_EVT_DATA,
            USER_GID : authSessionDto.ID,
            MD_SITEGID : authSessionDto.SITE_ITEM.SITEGID,
            MD_SITE_LIB : authSessionDto.SITE_ITEM.S_DENOMINATION,
            MD_CAISSE : localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') || '',
            MD_CAISSE_LIB : DEVICE!.C_NO + ' ' + DEVICE!.C_DENOMINATION,
            MD_CAISSIERGID : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CAISSIERGID,
            MD_CAISSIER_LIB : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CLU_USERLIB,
            MD_CAISSE_SESSION : DEVICE!.CAISSE_SESSION || '',
            MD_SITE_SESSION : DEVICE!.SITE_SESSION || '',
            MD_LOCALGID : DEVICE!.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID ?? '',
            ZSYNCUP_FLAG : 0,
            ZSYNCUP_STATUS : 'pending',
            ZSYNCUP_ERROR_MESSAGE : '',
            ZSYNCUP_DATETIME : '',
            ZSYNCUP_FEEDID : ''
        };
        return _zlogItem;
    }

    async doLogCashDeskZLogEvent_ZLogFn(LOG_EVT_CODE : string, LOG_EVT_TARGET : string, LOG_EVT_LIB : string, LOG_EVT_DATA : string) {
        try
        {
            if(!LOG_EVT_DATA || LOG_EVT_DATA == '') return;
            LOG_EVT_CODE = LOG_EVT_CODE ?? '';
            LOG_EVT_TARGET = LOG_EVT_TARGET ?? '';
            LOG_EVT_LIB = LOG_EVT_LIB ?? '';
            let _zLogItem = await this.doGetGenerateDefaultZLogItem_ZLogFn(LOG_EVT_CODE, LOG_EVT_TARGET, LOG_EVT_LIB, LOG_EVT_DATA);
            if(!_zLogItem || !_zLogItem.MD_CAISSE_SESSION) return;
            await this._cashDeskRxDbService.db.cluzlog.insert(_zLogItem);
        }
        catch { }
    }

}
